<template>
  <div
    class="flex flex-col gap-6 max-w-[24rem]"
  >
    <img
      :src="article.imageUrl || imagePlaceholder || '../../../images/placeholder.webp'"
      alt="Article image"
      class="w-full rounded-lg h-[18.75rem] aspect-auto object-cover"
      :class="[
        { '!h-[28.125rem]': bigImage && !autoHeightImage },
        { '!h-[unset]': autoHeightImage }
      ]"
    />
    <div class="flex flex-col gap-4">
      <div class="flex flex-wrap gap-2">
        <Tag v-for="(tag, index) in article.tags" :key="index" :tag="tag" />
        <span class="block w-full leading-[1.6875rem]"> 
          {{ article.readTime.toFixed(0) }} min read
        </span>

      </div>
      <div class="flex flex-col gap-2">
        <h5 class="text-[1.5rem] leading-[2.125rem] min-h-[4.25rem]">
          {{ article.title }}
        </h5>
        <span class="text-[1rem] leading-[1.5rem] line-clamp-2 min-h-[3rem]">
          {{ article.teaser }}
        </span>
      </div>
    </div>
    <a :href="article.path" class="flex gap-2 hover:underline">
      <span class="text-[1rem] leading-[1.5rem]">Read more</span>
      <span class="w-6 h-6 flex items-center justify-center">
        <svg viewBox="0 0 6 10" fill="currentColor" width="6px" height="10px">
          <path d="M0.5 10L5.5 5L0.5 0V10Z" fill="currentColor"/>
        </svg>
      </span>
    </a>
  </div>
</template>
<script>
import Tag from '../tag/index.vue'
export default {
  name: 'ArticleCard',
  components: {
    Tag
  },
  props: {
    imagePlaceholder: {
      type: String,
      default: ''
    },
    article: {
      type: Object,
      default: () => ({})
    },
    bigImage: {
      type: Boolean,
      default: false
    },
    autoHeightImage: {
      type: Boolean,
      default: false
    }
  }
}
</script>